// extracted by mini-css-extract-plugin
export default {"faqTop":"styles_faqTop__h94GP","faq":"styles_faq__Hu4N8","faqBottom":"styles_faqBottom__cwLuS"};